import { getConvertQuestionName, getQuestionTypeCode } from './convertTextData';

export const sortGbArr = [
    {
        value: '1',
        label: '최신 생성일 순',
    },
    {
        value: '2',
        label: '최근 수정일 순',
    },
    {
        value: '3',
        label: '가나다 순',
    },
];

export const sortGbMap: { [key: string]: string } = {
    '1': '최신 생성일 순',
    '2': '최근 수정일 순',
    '3': '가나다 순',
};

export const difyMap: { [key: string]: string } = {
    상: 'high',
    중: 'mid',
    하: 'low',
};

export const difyNumToString: { [key: string]: string } = {
    '60115': '상',
    '60116': '중',
    '60117': '중',
    '60118': '중',
    '60119': '하',
};

export const getRepresentArticleList = (_list: DATA.ArticleInfo[]): DATA.ArticleInfo[] => {
    // 대표 아티클 (articleId 당 1개) 목록 추출
    const list: DATA.ArticleInfo[] = [];

    for (const i in _list) {
        const newA = _list[i];
        const aleadyIdx = list.findIndex((a) => a.id == newA.id);
        if (aleadyIdx == -1) {
            list.push(newA); // 신규 articleId 라면 추가
        } else {
            const aleadyA = list[aleadyIdx];
            const aleadySubId = aleadyA.subId || 0;
            const newSubId = newA.subId || 0;
            if (aleadySubId > newSubId) {
                list[aleadyIdx] = { ...newA }; // 연쇄형 문항 가장 작은 subId로 세팅
            }
        }
    }

    return list;
};

export const getFilteredArticleList = (_list: DATA.ArticleInfo[]): DATA.ArticleInfo[] => {
    const list: DATA.ArticleInfo[] = [];

    for (const i in _list) {
        const newA = _list[i];
        const alreadyIdx = list.findIndex((a) => a.id === newA.id);
        if (alreadyIdx === -1) {
            list.push({
                ...newA,
                questionType: getQuestionTypeCode(newA.questionType),
            });
        } else {
            const alreadyA = list[alreadyIdx];
            const alreadySubId = alreadyA.subId || 0;
            const newSubId = newA.subId || 0;
            const score =
                (alreadyA.mdulScr ? alreadyA.mdulScr : 0) + (newA.mdulScr ? newA.mdulScr : 0);
            if (alreadySubId > newSubId) {
                list[alreadyIdx] = {
                    ...newA,
                    questionType: 46,
                    mdulScr: score,
                };
            } else {
                list[alreadyIdx].questionType = 46;
                list[alreadyIdx].mdulScr = score;
            }
        }
    }
    return list;
};

export const normalizeDifficulty = (name: string = '') => {
    if (name?.startsWith('중')) return '중';
    if (name?.startsWith('상')) return '상';
    if (name?.startsWith('하')) return '하';
    return name;
};

export const getDifficultyArticleList = (_list: DATA.ArticleInfo[]): DATA.ArticleInfo[] => {
    const list: DATA.ArticleInfo[] = [];

    for (const i in _list) {
        const newA = _list[i];
        const alreadyIdx = list.findIndex((a) => a.id === newA.id);

        const normalized = normalizeDifficulty(newA.mdulDifyNm!);
        if (alreadyIdx === -1) {
            list.push({
                ...newA,
                questionType: [getConvertQuestionName(newA.questionType?.toString() ?? '')].filter(
                    Boolean
                ),
                difficultyList: [{ mdulDifyNm: normalized, mdulDifyCount: 1 }],
            });
        } else {
            const alreadyA = list[alreadyIdx];
            const alreadySubId = alreadyA.subId || 0;
            const newSubId = newA.subId || 0;
            const score =
                (alreadyA.mdulScr ? alreadyA.mdulScr : 0) + (newA.mdulScr ? newA.mdulScr : 0);

            const diffArr = alreadyA.difficultyList as {
                mdulDifyNm: string;
                mdulDifyCount: number;
            }[];
            const found = diffArr.find((d) => d.mdulDifyNm === normalized);
            if (found) {
                found.mdulDifyCount++;
            } else {
                diffArr.push({ mdulDifyNm: normalized, mdulDifyCount: 1 });
            }

            if (alreadySubId > newSubId) {
                list[alreadyIdx] = {
                    ...newA,
                    questionType: [
                        ...alreadyA.questionType,
                        getConvertQuestionName(newA.questionType ?? ''),
                    ].filter(Boolean),
                    mdulScr: score,
                };
            } else {
                list[alreadyIdx].questionType = [
                    ...new Set(
                        [
                            ...alreadyA.questionType,
                            getConvertQuestionName(newA.questionType ?? ''),
                        ].filter(Boolean)
                    ),
                ];
                list[alreadyIdx].mdulScr = score;
            }
        }
    }
    const order = ['상', '중', '하'];
    list.forEach((item) => {
        item.difficultyList.sort(
            (a: any, b: any) => order.indexOf(a.mdulDifyNm) - order.indexOf(b.mdulDifyNm)
        );
    });

    return list;
};

export const getCountArticleList = (_list: DATA.ArticleInfo[]): DATA.ArticleInfo[] => {
    const list: DATA.ArticleInfo[] = [];

    for (const i in _list) {
        const newA = _list[i];
        // const alreadyIdx = list.findIndex((a) => a.id === newA.id);

        list.push({
            ...newA,
            questionType: [getConvertQuestionName(newA.questionType?.toString() ?? '')].filter(
                Boolean
            ),
            difficultyList: [
                { mdulDifyNm: normalizeDifficulty(newA.mdulDifyNm!), mdulDifyCount: 1 },
            ],
        });
    }
    return list;
};

interface LevelItem {
    metaId: number | string;
    limitCount: number;
}

export const buildLackMessageByMap = (
    items: LevelItem[],
    map: { [key: string]: string } = difyNumToString
): string | null => {
    // metaId→난이도 매핑을 난이도→[metaId…] 그룹으로 뒤집기
    const groups: { [level: string]: string[] } = {};
    for (const k in map) {
        const level = map[k];
        (groups[level] || (groups[level] = [])).push(k);
    }

    const order = ['상', '중', '하']; // 표시 순서 고정
    const lack: string[] = [];

    // 각 난이도 그룹 중 하나라도 limitCount>0 이면 그 난이도 부족으로 판단
    for (let i = 0; i < order.length; i++) {
        const level = order[i];
        const ids = groups[level] || [];
        let hasLack = false;

        for (let j = 0; j < items.length && !hasLack; j++) {
            const it = items[j];
            if (!it || typeof it.limitCount !== 'number') continue;
            if (it.limitCount > 0 && ids.indexOf(String(it.metaId)) !== -1) {
                hasLack = true; // OR 집계
            }
        }

        if (hasLack) lack.push(level);
    }
    console.log('lack', lack);
    if (lack.length === 0) return null;
    const joined = "'" + lack.join("', '") + "'";
    return joined + '에 해당하는 문항이 부족합니다.';
};

interface ArticleItem {
    difficultyEx?: string | number | null;
    // …그 외 필드 생략
}

interface RequiredCounts {
    high: number;
    middle: number;
    low: number;
}

/** 데이터에서 난이도별 개수 집계 */
export const countByDifficulty = (items: DATA.ArticleInfo[]) => {
    const cnt = { 상: 0, 중: 0, 하: 0 };
    for (let i = 0; i < items.length; i++) {
        const it = items[i];
        if (!it || it.difficultyEx == null) continue;
        const key = String(it.difficultyEx);
        const level = difyNumToString[key];
        if (!level) continue;
        cnt[level as keyof typeof cnt] += 1;
    }
    return cnt; // {상:n, 중:n, 하:n}
};

/** 부족 난이도 메시지 생성 (없으면 null) */
export const buildLackMessageFromItems = (
    items: DATA.ArticleInfo[],
    req: RequiredCounts
): string | null => {
    const cnt = countByDifficulty(items);
    const lack: string[] = [];

    if (cnt['상'] < (req.high || 0)) lack.push('상');
    if (cnt['중'] < (req.middle || 0)) lack.push('중');
    if (cnt['하'] < (req.low || 0)) lack.push('하');

    if (lack.length === 0) return null;
    const joined = "'" + lack.join("', '") + "'";
    return joined + '에 해당하는 문항이 부족합니다.';
};
